/* Divanique — open the cart drawer instead of loading the cart page.
 *
 * The Divanique product section uses a plain <form action="/cart/add">, which
 * makes the browser POST and navigate to /cart. Horizon's own buy buttons
 * avoid that by posting with fetch and firing a `cart:update` event, which the
 * drawer listens for.
 *
 * This file does the same thing for any cart form the theme does not already
 * manage, so the Divanique buy box and sticky bar behave like the native ones.
 * Forms inside <product-form-component> are left alone — Horizon owns those.
 *
 * If anything fails, the form is submitted the old way so a shopper is never
 * stuck with a dead button.
 */
(function () {
  'use strict';

  var SOURCE = 'divanique-cart';

  /* Horizon re-renders the drawer from server-rendered sections. Collect the
     section ids it expects so the response comes back with fresh markup. */
  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids.join(',');
  }

  function addUrl() {
    return (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return false;
    try {
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
    } catch (e) {
      return false;
    }
    return false;
  }

  /* Same event name and shape Horizon's own product form dispatches, so the
     drawer, the cart icon count and the line items all refresh themselves. */
  function announce(cart, sections) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: SOURCE,
        data: {
          source: SOURCE,
          itemCount: cart && cart.item_count,
          sections: sections
        }
      }
    }));
  }

  function submitNatively(form) {
    HTMLFormElement.prototype.submit.call(form);
  }

  function addToCart(form, button) {
    var body = new FormData(form);
    var ids = sectionIds();
    if (ids) body.set('sections', ids);

    if (button) button.disabled = true;

    fetch(addUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        /* Shopify returns a `status` key only when the add failed. */
        if (res.status) throw new Error(res.description || res.message || 'Add to cart failed');

        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            announce(cart, res.sections);
            if (!openDrawer()) window.location.href = '/cart';
          });
      })
      .catch(function (err) {
        console.error('[Divanique cart]', err);
        submitNatively(form);
      })
      .then(function () {
        if (button) button.disabled = false;
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.nodeName !== 'FORM') return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      /* Horizon already handles its own forms with fetch. Don't double up. */
      if (form.closest('product-form-component')) return;

      event.preventDefault();
      addToCart(form, form.querySelector('[type="submit"]'));
    },
    true
  );
})();
